<template>
  <el-container style="height: 100%">
    <div>
      <el-menu router unique-opened :default-active="this.$route.path" class="el-menu-vertical" @select="handleselect" :collapse="isCollapse" style="overflow: auto">
        <el-menu-item class="main-title" style="background-color: RGB(64, 157, 255) !important">
          <i v-if="isCollapse" style="font-size: 14px !important; font-weight: 600; color: #fff">{{ agentName }}</i>
          <span slot="title" v-else class="menu menu-title">{{
              agentName
          }}</span>
        </el-menu-item>
        <el-menu-item index="/index">
          <template>
            <i class="el-icon-third-homepage"></i>
            <span class="submenu">首页</span>
          </template>
        </el-menu-item>
        <el-submenu v-for="(menu, index) in menus" :index="index + 1 + ''" :key="menu.id">
          <template slot="title">
            <i :class="menu.icon"></i>
            <span slot="title" class="menu">{{ menu.name }}</span>
          </template>
          <el-menu-item v-for="submenu in menu.resources" :index="submenu.url" :key="submenu.id">
            <template slot="title">
              <span slot="title" class="submenu">{{ submenu.name }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div v-show="tagsVisible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu" @mouseleave="leave()" @mouseenter="tagsVisible = true">
      <!-- <div class="contextmenu_text" @click="refreshSelectedTag()">刷新页面</div> -->
      <div class="contextmenu_text" @click="closeSelectedTag()">关闭当前</div>
      <div class="contextmenu_text" @click="closeOthersTags()">关闭其他</div>
      <div class="contextmenu_text" @click="closeAllTags()">关闭所有</div>
    </div>

    <el-container>
      <!-- <el-header class="main-header" :style="'height:50px;background:' + color"> -->
      <!-- <el-header class="main-header" style="height:50px;background:#344058"> -->
      <el-header class="main-header" style="height: 50px; background: RGB(64, 157, 255)">
        <!-- <el-header class="main-header" style="height:50px;background:Rgb(64,158,255)"> -->

        <div class="headerFlex">
          <div class="collapseDiv">
            <i class="el-icon-s-fold collapseIcon" @click="isCollapse = true" v-show="!isCollapse"></i>
            <i class="el-icon-s-unfold collapseIcon" @click="isCollapse = false" v-show="isCollapse"></i>
          </div>
          <!-- <div class="collapseDiv" style="font-size:16px;margin-left:20px;">{{routeName}}</div> -->
          <div class="avaterDiv">
            <!-- <div>
              <div class="function-icon" @click="drawer = true">
                <i class="el-icon-brush"></i>
              </div>
              <el-drawer title="颜色配置" :visible.sync="drawer" :direction="direction">
                <div style="padding: 1rem;">
                  <h1>选择颜色</h1>
                  <el-color-picker
                    v-model="color"
                    show-alpha
                    :predefine="predefineColors"
                    @change="changeSubject"
                    @active-change="activeChangeSubject"
                  ></el-color-picker>
                </div>
              </el-drawer>
            </div>-->
            <div style="
                margin-right: 10px;
                float: right;
                display: flex;
                align-items: center;
              ">
              <el-popover placement="bottom-start" title="未读消息" width="250" trigger="hover" popper-class="notice-box">
                <el-row class="notice-count">
                  <el-col :key="noticeNumber">{{
                      noticeNumber == 0 ? "暂无消息~" : noticeNumber + "条新消息"
                  }}</el-col>
                </el-row>
                <el-row class="notice-operator" type="flex" justify="space-between">
                  <el-col>
                    <el-link type="primary" :underline="false" @click="noticeCenter">消息中心</el-link>
                  </el-col>
                  <el-col style="text-align: center">
                    <el-link type="primary" :underline="false" @click="markRead">全部标记为已读</el-link>
                  </el-col>
                </el-row>

                <el-badge slot="reference" :value="noticeNumber == 0 ? '' : noticeNumber" class="el-dropdown-link news-center">
                  <i class="el-icon-bell"></i>
                </el-badge>
              </el-popover>

              <el-dropdown>
                <div class="el-dropdown-link" style="display: flex">
                  <avatar :username="user.name ? user.name : '无'" :src="
                    user.headPic
                      ? user.headPic
                      : 'https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif'
                  " :size="40"></avatar>
                  <div class="el-dropdown-link header-username">
                    {{ user.name ? user.name : "无" }}
                  </div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="userInfoVisible = true">
                    <i class="el-icon-user"></i>个人信息
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="logout">
                    <i class="el-icon-right"></i>退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <div>
              <div class="header-username">{{user.name ? user.name : "无"}}</div>
            </div>-->
          </div>
        </div>
      </el-header>
      <div class="main-tabs" @mouseleave="leave()">
        <el-tabs v-model="currTabValue" type="card" @tab-remove="removeTab" @tab-click="currTab" @contextmenu.prevent.native="openMenu($event)">
          <el-tab-pane v-for="(item, index) in currTabArr" :key="index" :label="item.MenuName" :closable="item.URL !== '/index' ? true : false" :name="item.URL"></el-tab-pane>
        </el-tabs>
      </div>
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.auth"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.auth"></router-view>
      </el-main>
    </el-container>
    <el-dialog title="修改信息" :visible.sync="userInfoVisible" width="30%" left>
      <el-form ref="userInfoForm" :model="userInfoForm" :label-width="formLabelWidth" :rules="userInfoFormRules">
        <el-form-item label="头像" prop="avatar">
          <el-upload :headers="upLoadData" class="avatar-uploader" :action="fileAction" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="userInfoForm.headPic" :src="userInfoForm.headPic" class="avatar" />
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input v-model="userInfoForm.name" disabled placeholder="请输入用户姓名" auto-complete="off" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="用户账号" prop="name">
          <el-input v-model="userInfoForm.account" disabled placeholder="请输入用户账号" auto-complete="off" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="修改密码" prop="password">
          <el-input v-model="userInfoForm.password" type="password" placeholder="请输入密码" auto-complete="off" maxlength="64"></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户签名" prop="signature">
          <el-input
            v-model="userInfoForm.signature"
            placeholder="请输入用户签名"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="userInfoVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateUserInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!--消息中心-->
    <!--<el-dialog-->
    <!--title="消息通知"-->
    <!--:visible.sync="newsVisible"-->
    <!--width="30%"-->
    <!--:footer="null"-->
    <!--&gt;-->
    <!--<el-row>-->
    <!--<el-col class="mb20">标题：{{newsDetail.title}}</el-col>-->
    <!--<el-col>内容：-->
    <!--<p v-html="newsDetail.content"></p>-->
    <!--</el-col>-->
    <!--</el-row>-->

    <!--</el-dialog>-->
  </el-container>
</template>

<script>
import Avatar from "vue-avatar";
import submenu from "../common/submenu";
import menuItem from "../common/menuItem";
import menuHeader from "../common/menuHeader";

export default {
  components: {
    Avatar,
    submenu,
    menuItem,
    menuHeader,
  },
  data () {
    return {
      user: {},
      agentName: "",
      noticeNumber: 0,
      tagsVisible: false,
      top: 0,
      left: 0,
      menuShow: false,
      currTabArr: [{ MenuName: "首页", URL: "/index" }],
      routeName: localStorage.getItem("lastRouterName"),
      drawer: false,
      direction: "rtl",
      color: "",
      predefineColors: [
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
      defaultActiveIndex: "1",
      isCollapse: false,
      formLabelWidth: "80px",
      menuName: "68网校机构后台",
      menuList: [
        {
          name: "首页",
          icon: "el-icon-third-homepage",
          url: "/index",
        },
      ],
      noticeList: [],
      newsDetail: "",
      userInfoForm: {},
      userInfoFormRules: {},
      userInfoVisible: false,
      newsVisible: false,
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      imageUrl: "",
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      currTabValue: "",
      currtQuery: {},
    };
  },
  watch: {
    $route: function (to, from) {
      let obj = {
        url: to.path,
        name: to.name,
        query: to.query,
      };
      this.addCurrTabArr(obj);
      this.routeName = to.name;
      this.currTabValue = to.path;
      this.currtQuery = to.query;
    },
    userInfoVisible (val) {
      if (val) {
        this.userInfoForm = {
          name: this.user.name,
          headPic: this.user.headPic,
          account: this.user.account
          // signature: this.user.signature
        };
      } else {
        this.userInfoForm = {};
      }
    },
  },
  methods: {
    //  消息中心 start

    noticeCenter () {
      this.$router.push({
        path: "/noticeList",
      });
    },
    markRead () {
      this.api.user.noticeAllRead().then((res) => {
        if (res.success) {
          this.getNoticeList();
          this.$notify.closeAll();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //----------------处理已打开的tab-------------------------------------------------------------
    removeTab (targetUrl) {
      let tabs = this.currTabArr;
      let removeItem = (arr, item) => {
        //数组里移除指定元素
        let result = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] !== item) {
            result.push(arr[i]);
          }
        }
        return result;
      };

      this.currTabArr.forEach((item, index) => {
        if (item.URL === targetUrl && targetUrl != "/index") {
          this.currTabArr = removeItem(tabs, item);
          localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        }
      });
      if (this.currTabValue === targetUrl) {
        //如果移除的是当前已打开的tab，则给数组最后一个加上active
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      }
    },
    currTab (targetName) {
      this.currTabArr.forEach((e) => {
        if (this.currTabValue === e.URL) {
          this.currQuery = e.query;
        }
      });
      this.$router.push({ path: this.currTabValue, query: this.currQuery }); //当前tab跳转
    },
    addCurrTabArr (menu) {
      let sty = true;
      this.currTabArr.forEach((item) => {
        if (menu.url == item.URL) {
          sty = false;
        }
      });
      if (sty) {
        this.currTabArr.push({
          MenuName: menu.name,
          URL: menu.url,
          query: menu.query,
        });
      }
      localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
    },

    handleselect (index) {
      this.$router.push({ path: index });
    },
    initMenu () {
      if (localStorage.getItem("currTabArr")) {
        if (JSON.parse(localStorage.getItem("currTabArr")).length == 1) {
          this.currTabValue = "/";
        }
        if (JSON.parse(localStorage.getItem("currTabArr")).length > 1) {
          this.currTabArr = JSON.parse(localStorage.getItem("currTabArr"));
        }
        if (
          localStorage.getItem("lastRouter") &&
          localStorage.getItem("lastRouter") != "/"
        ) {
          this.currTabValue = localStorage.getItem("lastRouter");
        }
      }
      this.color = JSON.parse(localStorage.user).subject;
    },
    logout () {
      // this.$router.push("/");
      if (JSON.parse(localStorage.getItem("user")) != null) {
        this.api.logout({}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.$store.commit("signOut");
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        // alert(1);
        this.$store.commit("signOut");
        this.$router.push({ path: "/" });
      }
    },
    updateAgentUserInfoMyself () { },
    updateUserInfo () {
      this.userInfoForm.id = this.$store.state.loginData.openId;
      this.api.updateAgentUserInfoMyself(this.userInfoForm).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.userInfoVisible = false;
          this.initUserInfo();
          let aaa = true;
          if (this.$store.state.load) {
            aaa = false;
          } else {
            aaa = true;
          }
          this.$store.commit("changeLoad", aaa);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.userInfoForm.headPic = file.response.data;
    },
    beforeAvatarUpload (file) {
      // const isJPG = file.type === "image";
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    initUserInfo () {
      this.api.agentUserInfo
        .getAgentUserInfo({ id: this.$store.state.loginData.openId })
        .then((res) => {
          if (res.success) {
            this.user = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    changeSubject (val) {
      this.api.user
        .changeSubject({
          subject: val,
        })
        .then((result) => {
          if (result.success) {
            let user = JSON.parse(localStorage.user);
            user.subject = val;
            localStorage.setItem("user", JSON.stringify(user));
            this.$message.success(result.message);
            this.drawer = false;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    leave () {
      this.tagsVisible = false;
    },
    openMenu (e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right
      // console.log("offsetLeft",offsetLeft)
      // console.log("offsetWidth",offsetWidth)

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.tagsVisible = true;
      // this.selectedTag = tag
    },

    // refreshSelectedTag() {},
    closeSelectedTag () {
      let currRouter = localStorage.getItem("lastRouter");
      this.currTabArr.forEach((item, index) => {
        if (item.URL == currRouter) {
          this.currTabArr.splice(index, 1);
          localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
          this.tagsVisible = false;
          this.$router.push({
            path: this.currTabArr[this.currTabArr.length - 1].URL,
          });
        }
      });
    },
    closeOthersTags () {
      let currRouter = localStorage.getItem("lastRouter");
      let currRouterName = localStorage.getItem("lastRouterName");
      let obj = {
        MenuName: currRouterName,
        URL: currRouter,
      };
      if (currRouter == "/index") {
        this.currTabArr = [];
        this.currTabArr.push(obj);
        this.tagsVisible = false;
        localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      } else {
        this.currTabArr = [{ MenuName: "首页", URL: "/index" }];
        this.currTabArr.push(obj);
        this.tagsVisible = false;
        localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      }
    },
    closeAllTags () {
      this.currTabArr = [{ MenuName: "首页", URL: "/index" }];
      localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
      this.tagsVisible = false;
      this.$router.push({
        path: this.currTabArr[this.currTabArr.length - 1].URL,
      });
    },

    activeChangeSubject (val) {
      this.color = val;
    },
    openMenu (e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.tagsVisible = true;
      // this.selectedTag = tag
    },

    getNoticeList () {
      let that = this;
      this.api.user
        .pageList({
          pageSize: 10000,
          pageNumber: 1,
        })
        .then((res) => {
          if (res.success) {
            let unReadArr = [];
            this.noticeList = res.data.records;

            this.noticeList.forEach((item, index) => {
              if (item.flag == 0) {
                unReadArr.push(item);
              }
            });
            that.noticeNumber = unReadArr.length;
          } else {
            this.$message.error(res.message);
          }
        });

      //弹框通知
      this.api.user.getNewestNotice().then((result) => {
        if (result.success) {
          let _this = this;
          if (result.data != null && result.data != "") {
            this.$notify.warning({
              title: "通知消息",
              dangerouslyUseHTMLString: true,
              message:
                "<div>" +
                '<a href="javascript:;" style="color: #409eff;" >' +
                result.data.title +
                "</a>" +
                "</div>" +
                '<div class="pop-con">' +
                result.data.content +
                "</div>",
              position: "bottom-right",
              duration: 0,
              onClick () {
                this.$notify.closeAll();
                //  跳转到消息列表详情
                _this.$router.push({
                  path: "/noticeDetail",
                  query: { id: result.data.id },
                });
              },
            });
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
  },
  mounted () {
    if (localStorage.getItem("user")) {
      this.initMenu();
      this.initUserInfo();
      this.agentName = JSON.parse(localStorage.getItem("user")).agentName;
    }
  },
  created () {
    this.getNoticeList();
  },
  computed: {
    menus () {
      return this.$store.state.resources;
    },
    upLoadData () {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent",
      };
    },
  },
};
</script>

<style scoped lang="less">
.mb20 {
  margin-bottom: 20px;
}

.function-icon:hover {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  background: #bec2c8;
}

.el-icon-brush {
  font-size: 1.5rem;
  margin: 0 1rem 0 1rem;
}

.main-side {
  background-color: #344058;
  height: 100%;
}

.main-header {
  background-color: #344058;
}

.el-menu-vertical {
  max-width: 200px;
  height: 100%;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.menu {
  font-size: 14px;
}

.submenu {
  font-size: 14px;
}

.main-title {
  background-color: #409dff !important;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.menu-title-sub {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.collapseIcon {
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
}

.collapseDiv {
  float: left;
  height: 50px;
  line-height: 50px;
}

.menu-title {
  font-size: 18px !important;
  font-weight: 600;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.headerFlex {}

.avaterDiv {
  float: right;
  color: #fff;
  height: 50px;
  line-height: 50px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 1rem;
}

.el-dropdown-link {
  cursor: pointer;
}

.header-username {
  font-size: 16px;
  padding-left: 5px;
  line-height: 40px;
  color: #eee;
  /* color: Rgb(64,158,255); */
}

.contextmenu {
  position: absolute;
  z-index: 3000;
  background: #fff;
  padding: 10px 0;
  border-radius: 4px;
  line-height: 25px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.contextmenu_text {
  cursor: pointer;
  padding: 0 15px;
}

.contextmenu_text:hover {
  background: rgb(236, 245, 255);
}
</style>
<style lang="less" rel="stylesheet/less">
.pop-con {
  font-weight: bolder;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 2;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;

  img {
    width: 30px;
    height: 30px;
  }
}

.pop-con:hover {
  color: #409eff;
  cursor: pointer;
}

.notice-box {
  padding: 20px;

  .el-popover__title {
    font-weight: bolder;
    margin-bottom: 25px;
  }

  .notice-count>div {
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 2px solid #eee;
  }

  .notice-operator {
    padding: 15px 0 0;

    a span {
      font-size: 16px;
    }
  }
}

.news-center {
  margin-right: 25px;

  .el-icon-bell {
    font-size: x-large;
    color: #fff;
    top: 10px;
    position: relative;
  }

  .el-badge__content.is-fixed {
    top: 16px !important;
  }

  .mb20 {
    margin-bottom: 20px;
  }
}

.news-drop {
  &>.el-badge__content {
    right: -3px !important;
    top: 17px !important;
  }
}

.el-table--border {
  border: 1px solid #eee !important;
}

.el-table--border td {
  border-right: 1px solid #eee !important;
}

.el-table td {
  border-bottom: 1px solid #eee !important;
}

.el-table th.is-leaf {
  border-bottom: 1px solid #eee !important;
}

.el-table--border th {
  border-right: 1px solid #eee !important;
}

.main-tabs {
  .el-tabs__header {
    margin: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue